import React, { useMemo } from 'react';
import styled from 'styled-components';

import { Package } from './package/package';

export function PackageMonth({
    addTicket,
    addedTickets,
    confirmedPackage,
    confirmedTickets,
    inactive,
    numOfDatesToRender,
    onConfirmTickets,
    onDeselectPackage,
    onSelectPackage,
    onSelectTicket,
    onSelectTicketType,
    packages,
    removeTicket,
    selectedPackage,
    selectedTicket,
    selectedTicketType,
    stepTicketDone,
    ticketTypes,
}) {
    const selectedPackageIndex = useMemo(
        () => {
            if (selectedPackage == null) {
                return -1;
            }

            for (let i = 0, l = packages.length; i < l; ++i) {
                if ((packages)[i].ticket.id ===
                    selectedPackage.ticket.id) {
                    return i;
                }
            }

            return -1;
        },
        [selectedPackage, packages],
    );

    const items = [];
    for (let i = 0; i < packages.length; ++i) {
        items.push(
            <Package
                key={i}
                package={packages[i]}
                confirmedTickets={confirmedTickets}
                onSelectTicketType={onSelectTicketType}
                inactive={inactive ||
                    (selectedPackageIndex > -1 && i < selectedPackageIndex)}
                selectedTicket={selectedTicket}
                selectedTicketType={selectedTicketType}
                selectedPackage={selectedPackage}
                confirmedPackage={confirmedPackage}
                addedTickets={addedTickets}
                ticketTypes={ticketTypes}
                onSelectPackage={onSelectPackage}
                onSelectTicket={onSelectTicket}
                addTicket={addTicket}
                removeTicket={removeTicket}
                stepTicketDone={stepTicketDone}
                onConfirmTickets={onConfirmTickets}
                onDeselectPackage={onDeselectPackage}
            />,
        );

        if (selectedPackageIndex === i) {
            break;
        }
    }

    return (
        <Wrapper>
            {items}
        </Wrapper>
    );
}

const Wrapper = styled.div`
    .no-available-dates {
        padding: 15px 0;

        font-size: 14px;
        color: #999;
    }
`;
